import styled, { css } from 'styled-components';

export const ImageContainer = styled.div<{
  $aspectRatio?: string | null;
  $hasUrl?: boolean;
  $mediaWrapperType?: string;
  $scale?: number;
  $width?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $width }) => $width && `width: ${$width};`}
  overflow: hidden;

  &.banner-hero-image-single {
    display: block;
    @media (max-width: 767px) {
      height: auto;
      width: 100%;
      max-height: 260px;
    }

    @media (min-width: 768px) {
      min-height: 532px;
    }
  }

  &.banner-hero-image-double {
    @media (max-width: 767px) {
      height: auto;
      max-height: 260px;
      width: 100%;
    }

    @media (min-width: 768px) {
      min-height: 532px;
    }
  }

  &.end-image {
    height: 100%;
    @media (max-width: 767px) {
      height: auto;
      height: 400px;
      width: 100%;
    }
  }

  &.submenubox {
    @media (min-width: 768px) {
      height: 400px;
      width: auto;
    }
  }

  &.collection-header {
    @media (max-width: 767px) {
      height: 280px;
      width: 125px;
    }

    @media (min-width: 768px) {
      height: 220px;
    }
  }

  &.error {
    height: 100%;
  }

  ${({ $aspectRatio }) =>
    $aspectRatio &&
    css`
        aspect-ratio: ${$aspectRatio};
    }
  `}
  ${({ $mediaWrapperType }) =>
    $mediaWrapperType === 'MediaAndSideText' &&
    css`
      height: 100%;
      width: 100%;
      @media (max-width: 767px) {
        aspect-ratio: 17 / 10;
      }
      img {
        object-fit: cover;
      }
    `}
  &.loading,.error {
    > img {
      position: absolute;
    }
  }
  &.loaded {
    > img {
      opacity: 1;
      ${({ $scale }) => $scale && `transform: scale(${$scale})`};
    }
  }

  > img {
    height: 100%;
    width: 100%;

    &.image-1 {
      max-height: 95vw;
      width: auto;

      @media (min-width: 1024px) {
        max-height: 640px;
        width: auto;
      }

      @media (min-width: 1200px) {
        max-height: 690px;
        width: auto;
      }
    }

    &.end-image {
      @media (max-width: 767px) {
        height: 100%;
        width: auto;
      }
    }

    &.banner-hero-image-double,
    &.banner-hero-image-single {
      @media (max-width: 767px) {
        height: auto;
        width: 100%;
      }
    }

    &.submenubox,
    &.banner-hero-image-single,
    &.banner-hero-image-double,
    &.end-image {
      @media (min-width: 768px) {
        width: auto;
        height: 100%;
      }
    }

    transition: transform 1000ms;
  }
  ${({ $hasUrl }) =>
    $hasUrl &&
    css`
      cursor: pointer;
    `}
`;

export const LoaderWrapper = styled.div`
  &.image-1 {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    min-height: 95vw;
    width: auto;

    @media (min-width: 1024px) {
      min-height: 640px;
      width: auto;
    }

    @media (min-width: 1200px) {
      min-height: 690px;
      width: auto;
    }
  }
`;
